
<div :class="focusedOnboardingFlow ? '' : 'form__group--border py-32'">
  <h2 v-if="!focusedOnboardingFlow" class="heading-2 mb-24">Write a bio</h2>
  <BioAreaNotebox class="-mt-16" :careType="careType" />
  <fieldset>
    <legend class="sr-only">Write a bio</legend>
    <TextArea
      id="bio"
      ref="textAreaComponent"
      v-model="bio"
      class="mt-16"
      labelName="Profile bio"
      :characterCounter="true"
      :minCharacters="150"
      :maxCharacters="2500"
      :rows="8"
    />
    <HelperText
      :status="helperStatus.Neutral"
      text="Note: your profile will be public, so don't share any personal details, like your contact information, last name, or links to your portfolio or social profiles."
      customClasses="leading-4"
    />
  </fieldset>
</div>
